(function () {
    'use strict';

    a3_cabin_reports.directive('grading', grading);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name grading
    * @restrict E
    * @description
    *   Implementation of overall grading
    * @example
    *   Usage:
    *   <grading></grading>
    * @ngInject
    */
    function grading() {
        function link(scope, element, attrs) {

            scope.getRemainingCharacters = getRemainingCharacters;
            scope.validateGrading = validateGrading;
            scope.filterValidTrainees = filterValidTrainees;
            scope.filterTrainee = filterTrainee;
            scope.saveComment = saveComment;
         
            scope.isDayGrading = scope.type == "day";
            scope.hasCertificateExam = scope.type == "certificate";

            scope.isCheck = scope.phase == "Check";

            //Separate DayGrading and ReleaseGrading 
            scope.sessions = [];
            scope.trainees.filter(x => !x.Session.Absent).forEach(function(trainee){
                var session = scope.isDayGrading ? trainee.Session.DayGrading : trainee.Session.ReleaseGrading;
                session.Name = trainee.Name;
                session.AimsId = trainee.AimsId;
                session.CrewId = trainee.CrewId;

                if(scope.isDayGrading || (!scope.isDayGrading && !scope.isCheck && trainee.AvailableRelease) || (!scope.isDayGrading && scope.isCheck)){
                    scope.sessions.push(session);
                }
            });

            

            scope.sessions.forEach(function(traineeSession){
                validateGrading(traineeSession);
            });
            filterValidTrainees();
            

            /**
             * Calculate remaining characters for comment input
             * @param {string} text 
             * @param {number} max 
             */
            function getRemainingCharacters(text, max) {
                if (typeof (text) === "undefined" || text === null) return '';
                if (typeof (max) === "undefined" || max === null || max < 0 || !max) max = 4000;
                var length = text.length;

                return 'characters left: ' + (max - length);
            }
            
            function validateGrading(trainee){
                trainee.isGradeValid = trainee.Grade != null && trainee.Grade != undefined;
            }

            function filterValidTrainees(){
                scope.sessions.forEach(function(traineeSession){
                    traineeSession.isValid = traineeSession.isGradeValid && (!scope.settings.Competences.length || traineeSession.isCompetenceValid);   
                });
            }

            function filterTrainee(){
                return function( trainee ) {
                    var showTrainee = true;
                    if(scope.selected){ //individual grading view: filter selected
                        showTrainee = scope.selected.CrewId == trainee.CrewId
                    }
                    return showTrainee;
                };
            }

            function saveComment(){
                scope.commentInput();
            }
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/Training/grading.tpl.html',
            scope: {trainees:"=", settings:"=", type:"@", phase:"=", selected:"=", commentInput: "&onCommentInput"},
            link: link
        }
    }

})();
